import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/security/auth.service';
import { Comentario } from 'src/app/shared/model/tickets/comentario.model';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { TicketsService } from 'src/app/tickets/tickets.service';
import { TicketsEstatus } from 'src/app/utilerias/enums/tickets-estatus.enum';
import swal from 'sweetalert2';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatFormField, MatLabel, MatInput, MatSuffix } from '@angular/material/input';

@Component({
    selector: 'app-proceso-perfil-tickets',
    templateUrl: './proceso-perfil-tickets.component.html',
    styleUrls: ['./proceso-perfil-tickets.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatChipListbox, MatChipOption, MatFormField, MatLabel, MatInput, MatSuffix, MatButton]
})
export class ProcesoPerfilTicketsComponent {
  comentarioForm: FormGroup;
  datosTicket: Tickets;
  cambioEstatus: boolean;
  comentario: Comentario = new Comentario;
  dateNow: Date = new Date();
  fechaActual: Date; 
  constructor( public modalProceso: MatDialogRef<ProcesoPerfilTicketsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authS: AuthService,
    private toastr: ToastrService,
    private ticketsService: TicketsService,
    private formBuilder: FormBuilder,
  ){}
  ngOnInit() {
    this.datosTicket = Object.assign({}, this.data.datos)
    this.cambioEstatus = this.data.cambioEstatus;

    this.comentarioForm = this.formBuilder.group({
      comentarioPerfil: ['',Validators.required],
      fooBar:[],
    });
    this.llenarDatos();
  }

  llenarDatos() {
      this.authS.getSesion().subscribe(res => {      
      this.comentario.id_usuario = res.usuario.id;
      this.comentario.id_estatus = this.data.datos.id_estatus;
      this.comentario.id_ticket = this.data.datos.id_ticket;
    });
  }

  onCloseClick() {
    this.modalProceso.close();
  }

  limpiar(){
    this.comentarioForm.reset();
    this.modalProceso.close();
  }
  retornarEstatus(numero: number): TicketsEstatus {
    switch (numero) {
      case TicketsEstatus.ABIERTA:
        return TicketsEstatus.ABIERTA;
      case TicketsEstatus.PROCESO:
        return TicketsEstatus.PROCESO;
      case TicketsEstatus.ATENDIDA:
        return TicketsEstatus.ATENDIDA
      case TicketsEstatus.VOBO:
        return TicketsEstatus.VOBO;
      case TicketsEstatus.CANCELADA:
      default:
        return null;
    }
  }
  guardar(){
    if(this.datosTicket.id_estatus === 3){
      swal.fire({
        title: '¿Estás seguro?',
        text: "Este cambio de estatus no se podrá revertir",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3f9142',
        cancelButtonColor: '#f44336',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value) {         
         this.guardarEstatus();
        }
      })
    } else
      this.guardarEstatus();
  }
  guardarEstatus() {
    this.fechaActual = this.dateNow;
    if (this.cambioEstatus && this.cambioEstatus != undefined) {
      let status: TicketsEstatus;
      
      if (this.datosTicket.id_estatus != 6) {
        status = this.retornarEstatus(Number(this.datosTicket.id_estatus) + 1);
      } 
      else {
        status = TicketsEstatus.PROCESO;
      }
      this.datosTicket.id_estatus = status;
      this.comentario.id_estatus = this.datosTicket.id_estatus;
      this.ticketsService.editarEstatusDeTicket(this.datosTicket).subscribe(res => {
        if (res != null) {
          this.comentario.fecha = this.fechaActual;
          this.guardarComentario();
        } 
      else {
        this.toastr.error(' No se pudo editar el estatus del ticket. ', '  ', {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-" + "bottom" + "-" + "center",
        });    
        }
      });
    }
  }
  guardarComentario() {
    this.comentario.descripcion = this.comentarioForm.controls.comentarioPerfil.value;
    this.ticketsService.guardarComentario(this.comentario).subscribe(res => {
      if (res != null) {     
        this.toastr.info(' Se agregó comentario! ', '  ', {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-" + "bottom" + "-" + "center",
        }).onHidden.subscribe(() => {
          
          this.modalProceso.close();
        });
      } else {
        this.toastr.error(' No se pudo agregar comentario. ', '  ', {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-" + "bottom" + "-" + "center",
        });       
      }
    });
    
  }

}
